/* eslint-disable no-await-in-loop */
const createPoller = async (
  fetcher,
  {
    isSuccess,
    isFailure,
    signal,
    failureError = 'poll-failed',
    initialInterval = 2 * 1000,
    maxInterval = 30 * 1000,
    timeout = Infinity,
  },
) => {
  const startTime = Date.now();
  let interval = initialInterval;

  while (Date.now() - startTime < timeout) {
    if (signal?.aborted) {
      throw new DOMException('Aborted', 'AbortError');
    }

    const response = await fetcher();

    if (isFailure(response)) {
      throw new Error(failureError);
    }

    if (isSuccess(response)) {
      return response;
    }

    const currentInterval = interval;
    await new Promise((resolve, reject) => {
      const timer = setTimeout(resolve, currentInterval);
      signal?.addEventListener(
        'abort',
        () => {
          clearTimeout(timer);
          reject(new DOMException('Aborted', 'AbortError'));
        },
        { once: true },
      );
    });

    interval = Math.min(interval * 2, maxInterval);
  }

  throw new Error('poll-timeout');
};

export default createPoller;
